import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import { RootState } from '../reducers';
import { useDispatch } from 'react-redux';
import useEffectOnce from '../hooks/useEffectOnce';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { useNavigate } from 'react-router-dom';
import { Message } from 'primereact/message';
import { LoginService } from '../services/LoginService';
import { Card } from 'primereact/card';
import { Panel } from 'primereact/panel';
import { Admin_API, PATIENT_API } from '../ApiNames';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
// import { fetchFamilyData } from '../reduxactions/patientactions/PatientFamilyActions';
// import { fetchAPPLICATIONS } from '../reduxactions/patientactions/PatientApplicationsActions';
import { fetchAPPLICATIONS } from '../reduxactions/patientactions/PatientApplicationsActions';
export const PatientApplications = () => {
    const uid = window.sessionStorage.getItem('uid');

    const [globalFilter, setGlobalFilter] = useState('');

    const data = useSelector((state: RootState) => state.patientapplications.applications);

    const dispatch = useDispatch();


    const toast = useRef(data);

    //To get data
    const fetchDataAsync = async () => {
        try {
            await dispatch(fetchAPPLICATIONS(uid) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    useEffect(() => {
        fetchDataAsync();
    }, [dispatch]);
    const navigate = useNavigate();
    const navigateNewApplication = () => {
        const url = `/newapplicationpatient`;
        navigate(url);
    };
    const navigateViewApplication = (rowData: any) => {
        const url = `/viewpatapplications/${rowData.application_ID}`;
        navigate(url);
    };
    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/patientapplications.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };

    return (
        <div className="admin-layout-container">
            <div className="content-wrapper" style={{ marginLeft: '100px' }}>
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="grid mb-2">
                            <div className="col-6">
                            </div>
                        </div>
                    </div>
                </section>
                <section className="content" style={{ marginLeft: '110px' }} >
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card-header p-2" style={{ marginTop: '50px' }}>
                                <h2>Patient Applications List</h2>
                            </div>
                            <div className="col-16" style={{ textAlign: "right" }}>
                                <a
                                    title="help"
                                    onClick={(e) => openWindow(e, IUrl)}
                                    style={{

                                        color: "blue",
                                        fontSize: 15, cursor: "pointer"
                                    }}
                                >Help for this Page &nbsp;
                                    <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                                </a>
                            </div>
                            <br></br>
                            <div className="card flex flex-wrap justify-content-end" style={{ marginRight: '30px' }}>
                                <Button label="New Applications" severity="info" onClick={navigateNewApplication} />
                            </div>
                            <div className="box box-primary">
                                <div className="card">
                                    <p className="m-0">
                                        <div>
                                            <div className="card flex flex-wrap justify-content">
                                                <span className="p-input-icon-left">
                                                    <i className="pi pi-search" style={{ paddingLeft: '5px' }} />
                                                    <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" style={{ paddingLeft: '25px' }} />
                                                </span>

                                            </div>
                                            <DataTable value={data} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} filters={{ global: { value: globalFilter, matchMode: 'contains' } }}
                                                globalFilterFields={['FirstName', 'Sickness', 'hospitalname', 'status']}>
                                                <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                                <Column body={(rowData) => `${rowData.FirstName}`} sortable header="Patient Name"></Column>
                                                <Column field="Sickness" sortable header="Sickness"></Column>
                                                <Column field="hospitalname" sortable header="Hospital"></Column>
                                                <Column field="status" sortable header="Status"></Column>

                                                <Column header="Operation" body={(rowData) => (
                                                    <>
                                                        <Button className='mr-6' tooltip="View" severity="success" icon="pi pi-eye" rounded outlined onClick={() => navigateViewApplication(rowData)} />
                                                    </>
                                                )} />
                                            </DataTable>

                                        </div>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>



        </div>
    )
}
